import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Collapse from '@mui/material/Collapse'
import PropTypes from 'prop-types'
import { useState, memo } from 'react'
import { makeStyles } from 'tss-react/mui'

import colors from '../../../lib/Colors'
import fonts from '../../../lib/Font'

const useStyles = makeStyles()(() => ({
  summary: {
    background:
      'radial-gradient(at 50% 100%, #ffffff 0%, rgba(255, 255, 255, 0.04) 90%, rgba(255, 255, 255, 0) 100%), linear-gradient(44.88deg, #d9e1e9 0%, #edf4fc 100%)',
    fontFamily: fonts.family.lato,
    color: colors.gray_100,
    fontWeight: 'bold',
    fontSize: '24px',
    padding: '12px 10px',
    cursor: 'pointer',
    marginBottom: '24px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  iconExpanded: {
    fontSize: 30,
  },
  iconCollapsed: {
    fontSize: 30,
    transform: 'rotateX(180deg)',
  },
}))

const CampaignGroupHeader = ({ title, count, children }) => {
  const { classes } = useStyles()
  const [expanded, setExpanded] = useState(true)

  const handleCollapse = () => {
    setExpanded(!expanded)
  }

  return (
    <>
      <div className={classes.summary} onClick={handleCollapse}>
        <span>
          {title} {count ? `(${count})` : null}
        </span>
        <ExpandMoreIcon
          className={expanded ? classes.iconExpanded : classes.iconCollapsed}
        />
      </div>
      <Collapse in={expanded}>{children}</Collapse>
    </>
  )
}

CampaignGroupHeader.propTypes = {
  count: PropTypes.number,
  title: PropTypes.string,
}

CampaignGroupHeader.defaultProps = {
  count: 0,
}

export default memo(CampaignGroupHeader)
